import moment from 'moment'

const recurrenceTypes = {
  DAILY: 1,
  WEEKLY: 2,
  MONTHLY: 3,
}

const availableActivities = {
  AUDIOLOGY: 1,
  NUTRITION: 2,
  SCREENING: 3,
}

const state = {
  personDetails: null,
  permissions: null,
  holidays: [],
  recurrenceTypes,
  availableActivities,
  agendaErrors: {
    start_is_past: ['the_field_start_must_be_after_yesterday.'],
    end_is_before_start: ['the_field_end_must_be_after_start.'],
    recurrence_end_is_before_start: ['the_field_recurrence_end_must_be_after_start.'],
    recurrence_num_ocorrences_is_empty: ['the_field_recurrence_num_ocorrences_is_required_when_is_repeated_until_date_is_not_selected.'],
    recurrence_num_ocorrences_is_invalid_interval: ['the_field_recurrence_num_ocorrences_must_be_between_1_and_100.'],
    required_service_person: ['required_service_person.'],
    required_patient_name: ['required_patient_name.'],
    required_patient_phone: ['required_patient_phone.'],
    required_patient_email: ['required_patient_email'],
    invalid_patient: ['invalid_patient.'],
  },

}

const getters = {
  agendaErrors: state => state.agendaErrors,
  recurrenceTypes: state => state.recurrenceTypes,
  availableActivities: state => state.availableActivities,
  holidays: state => state.holidays,
}

const mutations = {
  setPersonDetails (state, data) {
    state.personDetails = data
  },
  setEbookingPermissions (state, data) {
    state.permissions = data
  },
  setHolidays (state, data) {
    state.holidays = data
  },
}

const actions = {
  loadEbookingPermissions ({ commit }, bookingUrl) {
    this._vm.$http({
      url: bookingUrl + '/permissions/me',
    }).then((response) => {
      //console.log(response)
      commit('setEbookingPermissions', response.data.data)
    }).catch((error) => {
      console.log(error)
    })
  },
  loadPersonDetails ({ commit }, bookingUrl) {
    this._vm.$http({
      // FIXME:
      url: bookingUrl + '/people/me',
    }).then(response => {
      let currentUser = response.data.data
      if (!currentUser.patient) {
        currentUser.patient = false
      }
      commit('setPersonDetails', currentUser)
    }).catch(error => {
      console.log(error)
    })
  },
  loadHolidays ({ commit }, bookingUrl) {
    return new Promise((resolve, reject) => {
      this._vm.$http({
        url: bookingUrl + '/holidays',
      }).then((response) => {
        response.data.data.map(item => {
          item.start = moment(item.date, 'YYYY-MM-DD')
        })
        commit('setHolidays', response.data.data)
        resolve()
      }).catch((error) => {
        console.log(error)
        reject(error)
      })
    })
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
